import { createStore } from 'redux';
import rootReducer from './rootReducer';

const devtools =
  process.browser && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f;

export default function(initialState, options) {
  return createStore(rootReducer, initialState, devtools);
}
